import Link from "carbon-react/esm/components/link";

interface SageJournalLinkProps {
  href: string;
  journalId: string;
}

export function SageJournalLink({ href, journalId }: SageJournalLinkProps) {
  return (
    <Link
      ariaLabel={`Open Sage journal ${journalId} in a new window`}
      href={href}
      rel="noopener noreferrer"
      target="_blank"
    >
      {journalId}
    </Link>
  );
}